import { useDroppable } from "@dnd-kit/core";

const Droppable = ({ id, path, children }) => {
  const { setNodeRef } = useDroppable({
    id,
    data: { path },
  });
  return <div ref={setNodeRef}>{children}</div>;
};

export default Droppable;
